export const CHANGE_PROPERTY = "CHANGE_PROPERTY";
export const CLEAR = "CLEAR";
export const LOAD = "LOAD";
export const REMOVE = "REMOVE";
export const UPDATE = "UPDATE";
export const SET_TYPE_PIASTRA = "SET_TYPE_PIASTRA";
export const CREATE_PROJECT = "CREATE_PROJECT";
export const SET_VERIFICA = "SET_VERIFICA";
export const SET_SELEZIONE = "SET_SELEZIONE";
export const SET_RESULTS = "SET_RESULTS";
export const SET_SELECTION_RESULTS = "SET_SELECTION_RESULTS";
export const SET_DEFAULT_VALUES = "SET_DEFAULT_VALUES";
export const SET_BLOCCO_CALCOLO = "SET_BLOCCO_CALCOLO";
